import Signup from '../components/signupHandler';
import FormMessageHandler from "../components/formMessageHandler";
import Recaptcha from "../components/recaptcha";

if ($("body").hasClass("page--enterprise_contact")) {
  let cacoo = require('../components/cacoo').cacoo;
  class EnterpriseContact {
    constructor() {
      this.signup = new Signup("enterpriseContactForm", {noEmailExistValidation: true});
      this.email = $("input#enterpriseEmail", this.signup.form);
      this.company = $('input[name="company"]', this.signup.form);
      this.numberOfUser = $('select[name="numberOfUser"]', this.signup.form);
      this.formMessageHandler = new FormMessageHandler(this.signup.form);
      this.recaptchaError = $('.error-message.recaptcha', this.signup.form);
      this.recaptchaError.html(Cacoo.SiteResources.recaptcha_error);
      this.recaptcha = new Recaptcha(this.signup.recaptchaToken);

      this.successOverlay = $('.form_success__overlay');
      this.successMessage = $('.form__success');

      this.attachEvent();
    }

    isValidDomain(email) {
      const domain    = email.split('@')[1]
      const blacklist = [
        'gmail.com',
        'hotmail.com',
        'hotmail.fr',
        'hotmail.it',
        'hotmail.es',
        'yahoo.com',
        'yahoo.es',
        'yahoo.fr',
        'yopmail.com',
        'email.com',
        'mail.ru',
        'outlook.com',
        'outlook.es',
        'naver.com',
      ];

      return !(blacklist.includes(domain));
    }

    attachEvent() {
      this.email.on('focusout', () => {
        this.mailValidate();
      });

      this.company.on('focusout', () => {
        this.companyValidation();
      });

      this.numberOfUser.on('focusout change', () => {
        this.numberOfUserValidation();
      });

      this.signup.submitButton.on('click', (e) => {
        e.preventDefault();
        this.submitForm();
        return true;
      });

    }

    companyValidation() {
      if (this.company.val().length == 0) {
        this.signup.formMessageHandler.showError('company', Cacoo.SiteResources['modal_signup_space_name_error']);
        return false;
      } else if (this.company.val().length >= 100) {
        this.signup.formMessageHandler.showError('company', Cacoo.SiteResources['modal_signup_space_name_length_error']);
        return false;
      }

      this.signup.formMessageHandler.showSuccess(['company']);
      return true;
    }

    numberOfUserValidation() {
      if(isNaN(parseInt(this.numberOfUser.val()))) {
        this.signup.formMessageHandler.showError('numberOfUser', Cacoo.SiteResources['enterprise_contact_number_of_user_error']);
        return false;
      }
      this.signup.formMessageHandler.showSuccess(['numberOfUser']);

      return true;
    }

    submitForm() {
      if (!this.signup.nameValidate()
        || !this.mailValidate()
        || !this.companyValidation()
        || !this.numberOfUserValidation()) {
        return false;
      }
      this.signup.submitForm(this, this.submitForm_loaded, this.submitForm_error);
    }

    submitForm_loaded(data) {
      this.successMessage.html(Cacoo.SiteResources["enterprise_contact_success"]);

      $.Velocity.animate(this.successOverlay, {
        opacity: .8
      }, {
        visibility: "visible"
      });

      $.Velocity.animate(this.successMessage, {
        opacity: 1
      }, {
        visibility: "visible"
      });
    }

    submitForm_error(err) {
      if(!err.errors) {
        this.signup.formMessageHandler.showError("default", Cacoo.SiteResources["modal_signup_default_error"]);
      } else {
        this.signup.formMessageHandler.showError(err.errors.field, err.errors.message);
      }
    }

    mailValidate() {
      const email = this.email.val();

      if(!cacoo.util.validateEmail(email) || !this.isValidDomain(email)) {
        this.formMessageHandler.showError('enterpriseEmail', Cacoo.SiteResources['enterprise_contact_email_error']);
        return false;
      }

      this.formMessageHandler.showSuccess(['enterpriseEmail']);
      return true;
    }
  }

  new EnterpriseContact();
}
